module.exports = __webpack_public_path__ + "img/xcx.7804d0fe.svg";